module.exports = __webpack_public_path__ + "img/iphone-safari-5_web_li.de105462.webp";